jQuery(document).ready(function($) {

    var action_url = '/cms/wp-admin/admin-ajax.php?action=memberarea_grid';

    function append_result(data) {

        if (data == "") {
            data = '<p>Keine weiteren Themen gefunden</p>';
        }

        $('.module-layotteroverviewwithfilter .next-teaser-wrapper').append(data).hide().fadeIn(200, function() {

            $('.loader').fadeOut(100, function() {
                $(this).remove();
            });

            if ($('.teaser').hasClass('last-item')) {
                $('#load-more-teaser').hide();
            }

            $('button.disabled').removeClass('disabled').attr('disabled', false);

        });

        $('[data-toggle="popover"]').popover({html: true, trigger: 'focus'});

    }

    function set_active_state(el) {
        $('.module-layotteroverviewwithfilter #filterbar').find('.active').removeClass('active');
        el.addClass('active');
    }

    function set_filter_info(filter) {
        $('.js-current-filter').text(filter);
    }

    function appendSpinner() {
        $('.module-layotteroverviewwithfilter .next-teaser-wrapper').empty().parent().append('<div class="loader fa-3x"><i class="fas fa-spinner fa-pulse"></i></div>');
        $('#load-more-teaser').hide();
    }


    //filter reset
    $('.js-delete-filter').click(function() {
        $('.module-layotteroverviewwithfilter #filterbar .active').removeClass('active');

        appendSpinner();

        $.post(action_url, {reset: true}, function(data) {
            append_result(data);
            $('.filter-info').removeClass('show');
            $('#load-more-teaser').show();
        });
    });

    //filter locations
    $('#mediaType li').click(function() {

        let mediaType = $(this).attr('class');

        set_active_state($(this));
        set_filter_info(mediaType);

        appendSpinner();

        $.post(action_url, {mediaType: mediaType}, function(data) {
            $(this).addClass('active');
            $('.filter-info').addClass('show');
            append_result(data);
        });

    });

    //filter topics
    $('#topics li').click(function() {

        var topic = $(this).text();

        set_active_state($(this));
        set_filter_info(topic);

        appendSpinner();

        $.post(action_url, {topic: topic}, function(data) {
            $(this).addClass('active');
            $('.filter-info').addClass('show');
            append_result(data);
        });

    });

    //load more button
    $('#load-more-teaser').click(function() {
        var lastDate = $('.module-layotteroverviewwithfilter .teaser').last().data('date');

        $(this).addClass('disabled').attr('disabled', true);

        $.post(action_url, {lastDate: lastDate}, function(data) {
            append_result(data);
        });

    });

    //default on page load, without prefiltering items

    if ($('.module-layotteroverviewwithfilter .next-teaser-wrapper').length && $('#mediaType .active').length == 0) {

        appendSpinner();

        //load all teasers

        $.post(action_url, {reset: true}, function(data) {
            append_result(data);
            $('.filter-info').removeClass('show');
            $('#load-more-teaser').show();
        });
    }

});
